export default class TreeRefreshArg{
	remoteClass="gongqi.erp.gotmodel.form.plugins.tree.TreeRefreshArg";
	opr;
	arg;
	static SET_DATA="SET_DATA";
	static SET_ICONS="SET_ICONS";
	static ADD_NODE="ADD_NODE";
	static DELETE_NODE="DELETE_NODE";
	static SELECT_NODE="SELECT_NODE";
	static UPDATE_NODE="UPDATE_NODE";
}


// WEBPACK FOOTER //
// ./src/forms/sys/remote/TreeRefreshArg.js